var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDowndist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.35 15.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#02ac85;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "downdist"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.12,5.76H1.23a.85.85,0,0,0-.64.33,1.22,1.22,0,0,0-.28.78,1.2,1.2,0,0,0,.28.77L7,15.37a.8.8,0,0,0,1.29,0l6.44-7.73A1.2,1.2,0,0,0,15,6.87a1.22,1.22,0,0,0-.28-.78A.85.85,0,0,0,14.12,5.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32,
    width: 6.72,
    height: 1.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 0.09,
    width: 15.35,
    height: 15.53
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowndist);
export default __webpack_public_path__ + "static/media/downdist.8b86720d4309d7da2940ba8d240bb520.svg";
export { ForwardRef as ReactComponent };